// THIS FILE IS AUTO-GENERATED by scripts/gen_config_schema.ts
// DO NOT EDIT directly — changes to config structs require regeneration.

import { z } from 'zod';

export const ArmyConfigSchema = z.object({
  groupRange: z.number().int().min(0).max(999),
  minClusterSize: z.number().int().min(0).max(999),
  maxGroupSize: z.number().int().min(0).max(999),
  cohesionRange: z.number().int().min(0).max(999),
  marchBonus: z.number().int().min(0).max(999),
  groupCoordBonus: z.number().int().min(0).max(999),
  flankingDivisor: z.number().int().min(0).max(100),
  shieldWallDivisor: z.number().int().min(0).max(100),
});

export const CityConfigSchema = z.object({
  moodDecayPerTick: z.number().int().min(0).max(100),
  moodDecayColosseum: z.number().int().min(0).max(100),
  foodSurplusThreshold: z.number().int().min(0).max(99999),
  noUnrestLoyaltyThreshold: z.number().int().min(0).max(100),
  noUnrestMoodThreshold: z.number().int().min(0).max(100),
  eliteDistributionCost: z.number().int().min(0).max(9999),
  peopleDistributionCost: z.number().int().min(0).max(9999),
  festivalFoodCost: z.number().int().min(0).max(9999),
  fundChurchCost: z.number().int().min(0).max(9999),
  cityVisionRange: z.number().int().min(0).max(999),
  tileControlInterval: z.number().int().nonnegative().min(1).max(999),
  entertainmentDemandPerPop: z.number().int().min(0).max(99999),
  popPerDemandUnit: z.number().int().min(0).max(99999),
  maxSatisfactionDropPerTick: z.number().int().min(0).max(100),
  eliteMeatCost: z.number().int().min(0).max(9999),
  eliteWineCost: z.number().int().min(0).max(9999),
  satisfactionDecayNoLuxury: z.number().int().min(0).max(100),
  satisfactionRecovery: z.number().int().min(0).max(100),
  repairCooldownTicks: z.number().int().nonnegative().min(1).max(999),
  conquestTicksThreshold: z.number().int().min(0).max(9999),
});

export const DiplomacyConfigSchema = z.object({
  napDefaultTerm: z.number().int().min(0).max(9999),
  proposalExpiry: z.number().int().min(0).max(9999),
  breakCooldown: z.number().int().min(0).max(9999),
  aiEvaluateInterval: z.number().int().nonnegative().min(1).max(999),
  alliedVictoryEnabled: z.boolean(),
});

export const HeroConfigSchema = z.object({
  recruitGoldCost: z.number().int().min(0).max(9999),
  maxPerPlayer: z.number().int().min(0).max(9999),
  loyaltyWarning: z.number().int().min(0).max(100),
  loyaltyDefection: z.number().int().min(0).max(100),
  loyaltyPenaltyLevelThreshold: z.number().int().min(0).max(100),
  loyaltyPenaltyHighLevel: z.number().int().min(0).max(100),
  loyaltyRivalryThreshold: z.number().int().min(0).max(100),
  loyaltyCityBonus_2Threshold: z.number().int().min(0).max(100),
  loyaltyCityBonus_1Threshold: z.number().int().min(0).max(100),
  loyaltyNoCityPenalty: z.number().int().min(0).max(100),
  cityBornMinPop_1pct: z.number().int().min(0).max(100),
  cityBornMinPopHalfPct: z.number().int().min(0).max(100),
  adventurerSpawnChance: z.number().int().min(0).max(100),
  adventurerSpawnDenominator: z.number().int().min(0).max(9999),
  defectionLoyaltyThreshold: z.number().int().min(0).max(100),
  romanceHexDistance: z.number().int().min(0).max(999),
  romanceProbability: z.number().int().min(0).max(100),
  captiveEscapeTickThreshold: z.number().int().min(0).max(9999),
  captiveEscapeChancePct: z.number().int().min(0).max(100),
  transferLoyaltyPenalty: z.number().int().min(0).max(100),
  transferMinLoyalty: z.number().int().min(0).max(100),
  capturedDurationTicks: z.number().int().nonnegative().min(1).max(999),
  defectorLoyalty: z.number().int().min(0).max(100),
});

export const IncomeConfigSchema = z.object({
  tradeGoldPerConnection: z.number().int().min(0).max(9999),
  maxConnectionsPerCity: z.number().int().min(0).max(9999),
  tradeRouteGoldPerTick: z.number().int().nonnegative().min(1).max(999),
  tradeRouteGrainPerTick: z.number().int().nonnegative().min(1).max(999),
});

export const MovementConfigSchema = z.object({
  movementModel: z.enum(['simple', 'detailed']),
  movementResetInterval: z.number().int().nonnegative().min(1).max(999),
  movementBiasDuration: z.number().int().nonnegative().min(1).max(999),
  arcaneMoveRange: z.number().int().min(0).max(999),
  roadMinDistance: z.number().int().min(0).max(999),
  roadCostPerTile: z.number().int().min(0).max(9999),
  convoySpeedOnRoad: z.number().int().min(0).max(9999),
  convoySpeedOffRoad: z.number().int().min(0).max(9999),
});

export const PrestigeConfigSchema = z.object({
  fameTrustThreshold: z.number().int().min(0).max(9999),
  fearGrievanceThreshold: z.number().int().min(0).max(9999),
  extremeFearThreshold: z.number().int().min(0).max(9999),
  fameTrustPerTier: z.number(),
  maxFameTrustBoost: z.number(),
  fearGrievancePerTier: z.number(),
  maxFearGrievanceBoost: z.number(),
});

export const DeliberationConfigSchema = z.object({
  deliberationInterval: z.number().int().nonnegative().min(1).max(999),
  useFunctionCalling: z.boolean(),
  goalsOverridePath: z.union([z.string(), z.null()]).optional(),
  domainBudgets: z.unknown(),
});

export const EspionageConfigSchema = z.object({
  intelDeliveryDepth1: z.number().int().min(0).max(9999),
  intelDeliveryDepth2: z.number().int().min(0).max(9999),
  intelDeliveryDepth3: z.number().int().min(0).max(9999),
  detectionChanceAdjacent: z.number().int().min(0).max(100),
  detectionChance_2hex: z.number().int().min(0).max(100),
  detectionFailedHit: z.number().int().min(0).max(9999),
  bodyguardBlockChance: z.number().int().min(0).max(100),
  bodyguardStrength: z.number().int().min(0).max(9999),
  bodyguardDiceSides: z.number().int().min(0).max(9999),
  intelBoostAuraRadius: z.number().int().min(0).max(999),
  intelBoostSpeedMultiplier: z.number().int().min(0).max(9999),
  spyNetworkIncrement: z.number().int().min(0).max(9999),
  crisisTickInterval: z.number().int().nonnegative().min(1).max(999),
  revoltMoodThreshold: z.number().int().min(0).max(100),
  revoltMoodChancePct: z.number().int().min(0).max(100),
  defectionMoodChancePct: z.number().int().min(0).max(100),
  defectionLoyaltyThreshold: z.number().int().min(0).max(100),
  defectionLoyaltyChancePct: z.number().int().min(0).max(100),
  successionAutoHeirChancePct: z.number().int().min(0).max(100),
  successionCapitalMoraleAssumption: z.number().int().min(0).max(9999),
  revolutionSatisfactionThreshold: z.number().int().min(0).max(100),
  revolutionNeutralChancePct: z.number().int().min(0).max(100),
  revolutionDefectChancePct: z.number().int().min(0).max(100),
  revolutionEnemyGoldWeightPct: z.number().int().min(0).max(100),
  revolutionEnemyDoctrineWeightPct: z.number().int().min(0).max(100),
  revolutionChancePerTickPct: z.number().int().min(0).max(100),
});

export const FaithConfigSchema = z.object({
  templeFaithRate: z.number().int().min(0).max(100),
  churchFaithRate: z.number().int().min(0).max(100),
  darkShrineFaithRate: z.number().int().min(0).max(100),
  popBonusThresholdMood: z.number().int().min(0).max(100),
  popBonusRate: z.number().min(0).max(1),
  overflowCapPerTick: z.number().int().nonnegative().min(1).max(999),
  unitMajorConvertChancePct: z.number().int().min(0).max(100),
  unitFanaticalDefectChancePct: z.number().int().min(0).max(100),
  faithRivalThreshold: z.number().int().min(0).max(9999),
  harvestNormal: z.number().int().min(0).max(9999),
  harvestUndead: z.number().int().min(0).max(9999),
  harvestReligious: z.number().int().min(0).max(9999),
});

export const ManaConfigSchema = z.object({
  manaFontRate: z.number().int().min(0).max(100),
  crystalMineRate: z.number().int().min(0).max(100),
  templeCrystalSynergyRate: z.number().int().min(0).max(100),
  darkShrineRate: z.number().int().min(0).max(100),
  darkCrystalMineRate: z.number().int().min(0).max(100),
  overflowCapPerTick: z.number().int().nonnegative().min(1).max(999),
  leyCityRadius: z.number().int().min(0).max(999),
  portalLightMpCost: z.number().int().min(0).max(9999),
  portalDarkMpCost: z.number().int().min(0).max(9999),
  portalLightManaCost: z.number().int().min(0).max(9999),
  portalDarkManaCost: z.number().int().min(0).max(9999),
  overflowThresholdPct: z.number().int().min(0).max(100),
});

export const CombineStyleConfigSchema = z.object({
  chaosEventChancePct: z.number().int().min(0).max(100),
  lawEventChancePct: z.number().int().min(0).max(100),
  chaosEventWeights: z.array(z.record(z.unknown())),
  lawEventWeights: z.array(z.record(z.unknown())),
  crisisDurationBase: z.number().int().nonnegative().min(1).max(999),
  successionAutoHeirProbabilityPct: z.number().int().min(0).max(100),
  powerStruggleExtraTicks: z.number().int().nonnegative().min(1).max(999),
  successsorLoyaltyPenalty: z.number().int().min(0).max(100),
});

export const SacrificeConfigSchema = z.object({
  minPopulation: z.number().int().min(0).max(99999),
  popFractionNumerator: z.number().int().min(0).max(99999),
  popFractionDenominator: z.number().int().min(0).max(99999),
  faithReturnNumerator: z.number().int().min(0).max(9999),
  faithReturnDenominator: z.number().int().min(0).max(9999),
  slaveFaithReturnNumerator: z.number().int().min(0).max(9999),
  slaveFaithReturnDenominator: z.number().int().min(0).max(9999),
  cooldownTicks: z.number().int().nonnegative().min(1).max(999),
  moodPenalty: z.number().int().min(0).max(100),
  loyaltyPenalty: z.number().int().min(0).max(100),
  faithThresholdCap: z.number().int().min(0).max(9999),
});

export const SiegeConfigSchema = z.object({
  evalInterval: z.number().int().nonnegative().min(1).max(999),
  moodPenalty: z.number().int().min(0).max(100),
  loyaltyPenaltyInterval: z.number().int().min(0).max(100),
  loyaltyPenalty: z.number().int().min(0).max(100),
  guardSiegeDamage: z.number().int().min(0).max(9999),
  popLoss: z.number().int().min(0).max(99999),
  surrenderMoodThreshold: z.number().int().min(0).max(100),
  surrenderLoyaltyThreshold: z.number().int().min(0).max(100),
  surrenderMinSiegeTicks: z.number().int().nonnegative().min(1).max(999),
  surrenderCapitalMoodThreshold: z.number().int().min(0).max(100),
  surrenderCapitalLoyaltyThreshold: z.number().int().min(0).max(100),
  surrenderCapitalMinSiegeTicks: z.number().int().nonnegative().min(1).max(999),
});

export const SlaveConfigSchema = z.object({
  foodEfficiencyPct: z.number().int().min(0).max(100),
  industryEfficiencyPct: z.number().int().min(0).max(100),
  goldEfficiencyPct: z.number().int().min(0).max(100),
  faithEfficiencyPct: z.number().int().min(0).max(100),
  revoltBaseChance: z.number().int().min(0).max(100),
  revoltLowMoodBonus: z.number().int().min(0).max(100),
  revoltFoodDeficitBonus: z.number().int().min(0).max(999),
  revoltHighRatioBonus: z.number().int().min(0).max(999),
  revoltCrisisMultiplier: z.number().int().min(0).max(9999),
  revoltSlaveLossMinPct: z.number().int().min(0).max(100),
  revoltSlaveLossMaxPct: z.number().int().min(0).max(100),
  revoltMoodPenalty: z.number().int().min(0).max(100),
  revoltLoyaltyPenalty: z.number().int().min(0).max(100),
});

export const PowerScoreConfigSchema = z.object({
  wMilitary: z.number(),
  wEconomic: z.number(),
  wPrestige: z.number(),
  wTerritory: z.number(),
  wDoctrine: z.number(),
});

export const NeutralTownConfig2Schema = z.object({
  minDistanceBetween: z.number().int().min(0).max(999),
  minDistanceFromPlayer: z.number().int().min(0).max(999),
  townsPerPlayer: z.number().int().min(0).max(9999),
  centerTowns: z.number().int().min(0).max(9999),
  populationRangeMin: z.number().int().min(0).max(999),
  populationRangeMax: z.number().int().min(0).max(999),
  townHp: z.number().int().min(0).max(99999),
  spawnRadiusNearPlayer: z.number().int().min(0).max(999),
  spawnRadiusNearCenter: z.number().int().min(0).max(999),
  leyMinDistFromStart: z.number().int().min(0).max(9999),
  leyMinNodes: z.number().int().min(0).max(9999),
  leyMaxNodes: z.number().int().min(0).max(9999),
});

export const MageAIConfigSchema = z.object({
  manaReservePct: z.number().int().min(0).max(100),
  damageSpellMinTier: z.number().int().min(0).max(9999),
  buffSpellMinTier: z.number().int().min(0).max(9999),
  ritualMinTier: z.number().int().min(0).max(9999),
  bootstrapMaxTier: z.number().int().min(0).max(9999),
  t1SpellMinMana: z.number().int().min(0).max(9999),
  t3SpellMinMana: z.number().int().min(0).max(9999),
  t4SpellMinMana: z.number().int().min(0).max(9999),
  cancelRitualMinTier: z.number().int().min(0).max(9999),
  cancelRitualMinMana: z.number().int().min(0).max(9999),
  faithRitualMinTier: z.number().int().min(0).max(9999),
  chaosRitualMinTier: z.number().int().min(0).max(9999),
  natureRitualMinTier: z.number().int().min(0).max(9999),
});

export const PersonalityConfigSchema = z.object({
  aggressionRangeMin: z.number().min(0).max(9999),
  aggressionRangeMax: z.number().min(0).max(9999),
  cautionRangeMin: z.number().min(0).max(9999),
  cautionRangeMax: z.number().min(0).max(9999),
  expansionismRangeMin: z.number().min(0).max(9999),
  expansionismRangeMax: z.number().min(0).max(9999),
  pietyRangeMin: z.number().min(0).max(9999),
  pietyRangeMax: z.number().min(0).max(9999),
  greedRangeMin: z.number().min(0).max(9999),
  greedRangeMax: z.number().min(0).max(9999),
  loyaltyRangeMin: z.number().min(0).max(1),
  loyaltyRangeMax: z.number().min(0).max(1),
  rationalityRangeMin: z.number().min(0).max(9999),
  rationalityRangeMax: z.number().min(0).max(9999),
  magicAffinityRangeMin: z.number().min(0).max(9999),
  magicAffinityRangeMax: z.number().min(0).max(9999),
  espionageAffinityRangeMin: z.number().min(0).max(9999),
  espionageAffinityRangeMax: z.number().min(0).max(9999),
  shuffleInterval: z.number().int().nonnegative().min(1).max(999),
});

export const VictoryConfigSchema = z.object({
  minEmpireTick: z.number().int().nonnegative().min(1).max(999),
  sustainEmpireTicks: z.number().int().nonnegative().min(1).max(999),
  economyGold: z.number().int().min(0).max(9999),
  economyTradeRoutes: z.number().int().min(0).max(9999),
  scienceKnowledge: z.number().int().min(0).max(99999),
  faithTotal: z.number().int().min(0).max(9999),
  faithTemples: z.number().int().min(0).max(9999),
  diplomacyHonor: z.number().int().min(0).max(9999),
  teamPowerThresholdPct: z.number().int().min(0).max(100),
  powerScoreVisibility: z.unknown(),
});

export const GameConfigSchema = z.object({
  cityMaxHp: z.number().int().min(0).max(99999),
  cityTierHpBonus: z.number().int().min(0).max(999),
  cityStartingPopulation: z.number().int().min(0).max(99999),
  foodPerPop: z.number().int().min(0).max(99999),
  growthFoodThreshold: z.number().int().min(0).max(99999),
  starvationPopLoss: z.number().int().min(0).max(99999),
  starvationThreshold: z.number().int().min(0).max(9999),
  cityLootGoldPerPop: z.number().int().min(0).max(9999),
  cityLootIndustryPerTier: z.number().int().min(0).max(9999),
  unitMaxHp: z.number().int().min(0).max(99999),
  unitAttack: z.number().int().min(0).max(9999),
  unitTypes: z.array(z.record(z.unknown())),
  surrenderHpThresholdPct: z.number().int().min(0).max(100),
  surrenderConversionCostPct: z.number().int().min(0).max(100),
  aiMoveInterval: z.number().int().nonnegative().min(1).max(999),
  aiAttackInterval: z.number().int().nonnegative().min(1).max(999),
  aiAttackDamage: z.number().int().min(0).max(9999),
  aiEarlyExplorationTicks: z.number().int().nonnegative().min(1).max(999),
  aiFogFrontierRadius: z.number().int().min(0).max(999),
  aiMinExploredForCombat: z.number().int().min(0).max(9999),
  aiBuildingInterval: z.number().int().nonnegative().min(1).max(999),
  aiDeliberationInterval: z.number().int().nonnegative().min(1).max(999),
  aiUseFunctionCalling: z.boolean(),
  deliberation: DeliberationConfigSchema,
  movement: MovementConfigSchema,
  incomeInterval: z.number().int().nonnegative().min(1).max(999),
  slowIncomeInterval: z.number().int().nonnegative().min(1).max(999),
  baseFoodPerCity: z.number().int().min(0).max(99999),
  doctrineThreshold: z.number().int().min(0).max(9999),
  doctrineMaxPerArchetype: z.number().int().min(0).max(9999),
  doctrineSeedPool: z.number().int().min(0).max(9999),
  doctrineGrantInterval: z.number().int().nonnegative().min(1).max(999),
  doctrineMaxPool: z.number().int().min(0).max(9999),
  healTickInterval: z.number().int().nonnegative().min(1).max(999),
  industryAttackBonusPerLevel: z.number().int().min(0).max(9999),
  industryLevels: z.number().int().min(0).max(9999),
  cityRegenInterval: z.number().int().nonnegative().min(1).max(999),
  cityRegenAmount: z.number().int().min(0).max(999),
  guardIndustryCost: z.number().int().min(0).max(9999),
  repairCostPerHp: z.number().int().min(0).max(9999),
  landUnitUpkeepGold: z.number().int().min(0).max(9999),
  heroUpkeepGold: z.number().int().min(0).max(9999),
  faithCityHealInterval: z.number().int().nonnegative().min(1).max(999),
  faithHealAmount: z.number().int().min(0).max(9999),
  faithCrisisSchismChancePct: z.number().int().min(0).max(100),
  faithCrisisUprisingChancePct: z.number().int().min(0).max(100),
  faithCrisisHolyWarChancePct: z.number().int().min(0).max(100),
  faithCrisisPilgrimageGoldCost: z.number().int().min(0).max(9999),
  faithCrisisReformFaithCost: z.number().int().min(0).max(9999),
  faithCrisisDeescalationCooldown: z.number().int().min(0).max(9999),
  garrisonHealInterval: z.number().int().nonnegative().min(1).max(999),
  engineerRepairInterval: z.number().int().nonnegative().min(1).max(999),
  engineerRepairHpPerUnit: z.number().int().min(0).max(99999),
  engineerRepairIndustryCost: z.number().int().min(0).max(9999),
  maxEngineerRepairUnits: z.number().int().min(0).max(9999),
  startingFood: z.number().int().min(0).max(99999),
  startingIndustry: z.number().int().min(0).max(9999),
  startingKnowledge: z.number().int().min(0).max(99999),
  startingFaith: z.number().int().min(0).max(9999),
  startingGold: z.number().int().min(0).max(9999),
  knowledgeMilestones: z.array(z.number().int()),
  researchCostKnowledge: z.number().int().min(0).max(9999),
  researchDurationTicks: z.number().int().nonnegative().min(1).max(999),
  researchIndustryBonus: z.number().int().min(0).max(9999),
  researchKnowledgeBonus: z.number().int().min(0).max(999),
  biomeYieldPlainsFood: z.number().int().min(0).max(99999),
  biomeYieldForestIndustry: z.number().int().min(0).max(9999),
  biomeYieldForestMeat: z.number().int().min(0).max(9999),
  biomeYieldHillsIndustry: z.number().int().min(0).max(9999),
  biomeYieldHillsKnowledgeSlow: z.number().int().min(0).max(99999),
  biomeYieldMountainKnowledgeSlow: z.number().int().min(0).max(99999),
  biomeYieldCoastGold: z.number().int().min(0).max(9999),
  biomeYieldCoastMeat: z.number().int().min(0).max(9999),
  biomeYieldRiverGrain: z.number().int().min(0).max(9999),
  biomeYieldRiverMeat: z.number().int().min(0).max(9999),
  biomeYieldRiverGold: z.number().int().min(0).max(9999),
  biomeYieldOceanMeatWithHarbour: z.number().int().min(0).max(9999),
  natureForestFoodBonus: z.number().int().min(0).max(999),
  chaosAttackBonus: z.number().int().min(0).max(999),
  chaosSelfDamagePenalty: z.number().int().min(0).max(9999),
  scienceKnowledgePerCitySlow: z.number().int().min(0).max(99999),
  buildings: z.array(z.record(z.unknown())),
  empireInterval: z.number().int().nonnegative().min(1).max(999),
  maxBuildQueuePerCity: z.number().int().min(0).max(9999),
  buildingWorkshopIndustryBonus: z.number().int().min(0).max(9999),
  buildingLibraryKnowledgeSlow: z.number().int().min(0).max(99999),
  buildingTempleFaithSlow: z.number().int().min(0).max(9999),
  buildingMarketGoldBonus: z.number().int().min(0).max(9999),
  buildingFarmFoodBonus: z.number().int().min(0).max(999),
  buildingMineIndustryBonus: z.number().int().min(0).max(9999),
  resources: z.array(z.record(z.unknown())),
  convoyCapacity: z.number().int().min(0).max(9999),
  roadConnectedGoldBonus: z.number().int().min(0).max(9999),
  tradeRoutesEnabled: z.boolean(),
  formationsEnabled: z.boolean(),
  bodyguardCost: z.number().int().min(0).max(9999),
  maxBodyguardsPerConvoy: z.number().int().min(0).max(9999),
  convoyGoldDamage: z.number().int().min(0).max(9999),
  depot: z.record(z.unknown()),
  sackSlavePct: z.number().int().min(0).max(100),
  sackCaptiveRate: z.number().int().min(0).max(100),
  sackSlaveFoodPerTick: z.number().int().nonnegative().min(1).max(999),
  convoyBaseGoldByTier: z.array(z.number().int()),
  convoyBaseFoodByTier: z.array(z.number().int()),
  convoyMarketGoldBonus: z.number().int().min(0).max(9999),
  convoyMarketFoodBonus: z.number().int().min(0).max(999),
  personalityShuffleInterval: z.number().int().nonnegative().min(1).max(999),
  personality: PersonalityConfigSchema,
  goalsOverridePath: z.union([z.string(), z.null()]).optional(),
  diplomacy: DiplomacyConfigSchema,
  income: IncomeConfigSchema,
  mountainResources: z.record(z.unknown()),
  mageAi: MageAIConfigSchema,
  victory: VictoryConfigSchema,
  siege: SiegeConfigSchema,
  espionage: EspionageConfigSchema,
  sacrifice: SacrificeConfigSchema,
  faith: FaithConfigSchema,
  mana: ManaConfigSchema,
  army: ArmyConfigSchema,
  slave: SlaveConfigSchema,
  powerScore: PowerScoreConfigSchema,
  hero: HeroConfigSchema,
  city: CityConfigSchema,
  prestige: PrestigeConfigSchema,
  combineStyle: CombineStyleConfigSchema,
  rituals: z.array(z.record(z.unknown())),
  neutralTowns: NeutralTownConfig2Schema,
});

export type GameConfig = z.infer<typeof GameConfigSchema>;
